import usePrivateAxios from "@/common/api/usePrivateAxios";
import { getCleanPayload } from "@/common/utils/getCleanPayload";
import { removeSpecialCharacters } from "@/common/utils/unFormatters";
import { PrivateCompanyLeadsFunnelUpdateContactValidationSchema } from "@/features/privateCompanyLeadsFunnel/schemas/update.schema";
import { useMutation } from "@tanstack/react-query";
import { AxiosResponse } from "axios";

interface UseUpdatePrivateCompanyLeadContact {
  contactId?: string,
  privateCompanyLeadId?: string,
  onSuccess: (reponse: AxiosResponse) => void,
  onError: (error: any) => void
}

const useUpdatePrivateCompanyLeadContact = ({ contactId, privateCompanyLeadId, onSuccess, onError }: UseUpdatePrivateCompanyLeadContact) => {
  const privateAxios = usePrivateAxios();
  return useMutation({
    mutationKey: ['updateContact'],
    mutationFn: (data: Partial<PrivateCompanyLeadsFunnelUpdateContactValidationSchema>) => {
      const payload = {
        contacts_attributes: [
          {
            ...data.contacts,
            phone_attributes: {
              number: data.contacts?.phone !== undefined
                ? data.contacts.phone?.number ? removeSpecialCharacters(data.contacts.phone.number) : ''
                : undefined,
            },
            id: contactId,
            cpf: data.contacts?.cpf !== undefined
              ? data.contacts?.cpf ? removeSpecialCharacters(data.contacts.cpf) : ''
              : undefined,
            documents_attributes: data.contacts?.documents?.filter((document) => document?.checked).map((document) => {
              const doc = {
                ...document,
                cnh: document?.cnh !== undefined
                  ? document?.cnh ? removeSpecialCharacters(document.cnh) : null
                  : undefined,
              }

              delete doc.type;
              delete doc.doc_options;

              return doc
            }),
          }
        ]
      }

      delete payload.contacts_attributes[0].documents;

      return privateAxios.putForm(`/funnel/private_company_leads/${privateCompanyLeadId}`, {
        private_company_lead: getCleanPayload(payload),
      })
    },
    onSuccess,
    onError,
  });
}

export default useUpdatePrivateCompanyLeadContact
